import { ServiceCustomer } from '@/service/customer/serviceCustomer'

const serviceCustomer = new ServiceCustomer()

export default {
  namespaced: true,
  state: {
    loading: false,
    listPatientArea: [],
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_LIST_PATIENT_AREA(state, payload) {
      state.listPatientArea = payload
    },

  },
  getters: {
    loading: state => state.loading,
    listPatientArea: state => state.listPatientArea,
  },
  actions: {
    async getPatientArea({ commit }) {
      commit('SET_LOADING', true)
      try {
        const response = await serviceCustomer.patientAreaCustomer()
        commit('SET_LIST_PATIENT_AREA', response.appointments_by_year)
        commit('SET_LOADING', false)
        return response
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
  },

}
